import { Geometry } from "geojson";

import { GqlPlannerV2MapElementPointType, GqlPlannerV2TravelType } from "~/__generated__";

import { PlannerV2TravelGroupGetTimelineQuery } from "../../queries.generated";

type MapPoint = NonNullable<PlannerV2TravelGroupGetTimelineQuery["mapElements"]>["points"][number];

export type LocationMetadata = {
    coordinates: Geometry;
    pointType: GqlPlannerV2MapElementPointType;
    shiftHasSecondaryTravel: boolean;
};

export function buildLocationMetadataByShiftIdMap(points: MapPoint[] | undefined): Map<string, LocationMetadata> {
    const map = new Map<string, LocationMetadata>();

    if (!points) return map;

    points.forEach(point => {
        point.plannerShiftTravels.forEach(shiftTravel => {
            map.set(shiftTravel.plannerShiftId, {
                coordinates: point.locationPoint,
                pointType: point.type,
                shiftHasSecondaryTravel:
                    shiftTravel.plannerShift.plannerShiftTravels.some(
                        shiftTravel => shiftTravel.plannerTravel.type === GqlPlannerV2TravelType.Secondary,
                    ) ?? false,
            });
        });
    });

    return map;
}
